<template>
	<div style="overflow-y: auto;height: calc(100vh - 110px);">
		<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px"
			class="postForm">
			<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
				会员费设置
			</div>
			<el-form-item label="按月会员费:" label-width="150px">
				<el-input v-model="addForm.monthFee" auto-complete="off" class="formItem150" size="small" maxLength="50" /> 元
			</el-form-item>
			<el-form-item label="按年会员费:" label-width="150px">
				<el-input v-model="addForm.yearFee" auto-complete="off" class="formItem150" size="small" maxLength="50" /> 元
			</el-form-item>
			<el-form-item label="推广用户奖励时长:" label-width="150px">
				<el-input v-model="addForm.offerTimes" auto-complete="off" class="formItem150" size="small"
					maxLength="50" /> 天数
			</el-form-item>
			<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
				难易程度积分设置
			</div>
			<el-form-item label="必做题积分:" label-width="150px">
				<el-input v-model="addForm.levelScoreType1" auto-complete="off" class="formItem150" size="small"
					maxLength="50" />
			</el-form-item>
			<el-form-item label="简单题积分:" label-width="150px">
				<el-input v-model="addForm.levelScoreType2" auto-complete="off" class="formItem150" size="small"
					maxLength="50" />
			</el-form-item>
			<el-form-item label="中等题积分:" label-width="150px">
				<el-input v-model="addForm.levelScoreType3" auto-complete="off" class="formItem150" size="small"
					maxLength="50" />
			</el-form-item>
			<el-form-item label="困难题积分:" label-width="150px">
				<el-input v-model="addForm.levelScoreType4" auto-complete="off" class="formItem150" size="small"
					maxLength="50" />
			</el-form-item>
			<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
				公司信息
			</div>
			<el-form-item label="公司名称:" label-width="150px" prop="corpName">
				<el-input v-model="addForm.corpName" auto-complete="off" class="formItem" size="small"
					maxLength="300" />
			</el-form-item>

			<el-form-item label="版权说明:" label-width="150px" prop="copyrightRemark" v-if="1==2">
				<el-input v-model="addForm.copyrightRemark" type="textarea" :rows="4" auto-complete="off" size="small"
					class="formItem450" />
			</el-form-item>

			<el-form-item label="关于我们:" label-width="150px" prop="aboutUs" v-if="1==2">
				<el-input v-model="addForm.aboutUs" type="textarea" :rows="4" auto-complete="off" class="formItem450"
					size="small" />
			</el-form-item>
			<el-form-item label="注册协议:" label-width="150px" prop="userAgreement" v-if="1==2">
				<el-input v-model="addForm.userAgreement" type="textarea" :rows="4" auto-complete="off" size="small"
					class="formItem450" maxLength="65535" />
			</el-form-item>
			<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
				联系方式
			</div>
			<el-form-item label="官方微信号:" label-width="150px" prop="weixi">
				<el-input v-model="addForm.weixi" auto-complete="off" class="formItem" size="small" maxLength="50" />
			</el-form-item>
			<el-form-item label="联系客服:" label-width="150px" prop="linkKefu">
				<el-input v-model="addForm.linkKefu" auto-complete="off" class="formItem300" size="small" />
			</el-form-item>
		</el-form>			
		<div slot="footer" class="dialog-footer" style="padding-left: 50%;margin-bottom: 50px;">
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: "addSave",
	data() {
		return {
			addForm: {},
			roleIDsDict: [],
			userRules: {},
			dialogAddShow: true,
		};
	},
	created() {
		this.initData();
	},
	methods: {
		initData() {
			this.$axios
				.get(
					"/basic/getwebconfigsetinfo?id=" +
					this.mid +
					"&rnd=" +
					new Date().getTime()
				)
				.then((res) => {
					this.addForm = res.data.data;
					this.loadDict();
				});
		},
		loadDict() { },
		handleSubmit() {
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.addForm.aboutUs="test"
					this.addForm.copyrightRemark="test"
					let formData = this.$util.jsonToForm(this.addForm);
					this.$axios.post("/basic/webconfigsetsave", formData).then((res) => {
						if (res.data.status == 0) {
							this.$message("保存成功!");
						} else {
							this.$message(res.data.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
